import { BaseEntity } from './dataTypes';

export const INITIAL_BASE_ENTITY: BaseEntity = {
  id: '',
  ownerId: '',
  identityId: '',
  owner: null,
  createdDate: '',
  updatedDate: '',
  entityStatus: '',
};

export const ENTITIES = {
  FILE_METADATA: 'FILE_METADATA',
  FILE_CHANNEL: 'FILE_CHANNEL',
  STRIPE_INVOICE: 'STRIPE_INVOICE',
  STRIPE_SUBSCRIPTION: 'STRIPE_SUBSCRIPTION',
  INTERNAL_USER: 'USER',
  CLIENT_USER: 'CLIENT_USER',
  CLIENT_COMPANY: 'CLIENT_COMPANY',
  INTAKE_FORM_RESPONSE: 'INTAKE_FORM_RESPONSE',
  NOTIFY_FILE_UPLOADED: 'NOTIFY_FILE_UPLOADED',
  NOTIFY_FILE_ESIGN_REQUEST: 'NOTIFY_FILE_ESIGN_REQUEST',
  NOTIFY_FILE_ESIGN_REQUEST_COMPLETE: 'NOTIFY_FILE_ESIGN_REQUEST_COMPLETE',
  NOTIFY_FORM_COMPLETE: 'NOTIFY_FORM_COMPLETE',
  NOTIFY_FORM_REQUEST: 'NOTIFY_FORM_REQUEST',
  PAYMENT_INFO: 'PAYMENT_INFO',
  INTAKE_FORM_TEMPLATE: 'INTAKE_FORM_TEMPLATE',
  ONBOARDING_TASK: 'ONBOARDING_TASK',
  DOMAIN_SETTINGS: 'DOMAIN_SETTINGS',
  NOTIFY_NEW_INVOICE: 'NOTIFY_NEW_INVOICE',
  PORTAL_SETTINGS: 'PORTAL_SETTINGS',
  PORTAL_CONFIG: 'PORTAL_CONFIG',
  MESSAGE_SETTINGS: 'MESSAGE_SETTINGS',
  CLIENT_CUSTOM_FIELDS: 'CLIENT_CUSTOM_FIELDS',
  EXTENSION_ITEM: 'DASHBOARD',
  TAG: 'TAG',
  ARTICLE: 'ARTICLE',
  KNOWLEDGE_BASE_SETTINGS: 'KNOWLEDGE_BASE_SETTINGS',
  REFERRAL: 'REFERRAL',
  NOTIFICATION_GROUPING: 'NOTIFICATION_GROUPING',
  FORM_RESPONSE: 'FORM_RESPONSE', // forms v2 response entity
  FORM_TEMPLATE: 'FORM_TEMPLATE',
};

export enum EntityStatus {
  Deleted = 'DELETED',
  Archived = 'ARCHIVED',
}
